import React, { useState } from 'react';
import styled from 'styled-components';
import {
  StyledDropdown,
  StyledDropdownToggle,
  Item,
  ToggleButton,
  Menu,
  Label,
} from '_Cards/FilterCards/DataByFiltersCard/_Containers/Dropdowns/utils/DropdownStyles';
import Icon from '_Components/Icons/Icon';
import { ImageSize } from 'styles/abstracts/variables';
import { grayShades } from 'styles/abstracts/colors';

export const BackItem = styled(Item)`
  justify-content: flex-start !important;
  padding-left: 0.25em !important;
  color: ${grayShades.g800} !important;
`;

type ThematicType = {
  thematic: string;
  subThematic: string | null;
  subSubThematic: string | null;
};

type ThematicSelectionType = {
  id: number | null;
  label: string;
  name: string;
  projectId: number;
  thematics: Array<ThematicType>;
  createdBy: {
    firstName: string;
    lastName: string;
    email: string;
  };
};

type ThematicSelectionDropdownProps = {
  id: string;
  label: string;
  benchmark: boolean;
  t: any;
  options: Array<ThematicSelectionType>;
  thematicSelection: ThematicSelectionType;
  setThematicSelection: any;
};

const ThematicSelectionDropdown = ({
  id,
  label,
  benchmark,
  t,
  options,
  thematicSelection,
  setThematicSelection,
}: ThematicSelectionDropdownProps) => {
  const [isDropdownOpen, openDropdown] = useState<boolean>(false);
  const [currentItem, setCurrentItem] = useState<ThematicSelectionType>(
    options.find(option => option.id === thematicSelection?.id) || options[0],
  );

  return (
    <>
      {!benchmark && (
        <div id={id}>
          <Label>{t(label)}</Label>
          <StyledDropdown direction="down" isOpen={isDropdownOpen} toggle={() => openDropdown(!isDropdownOpen)}>
            <StyledDropdownToggle>
              <ToggleButton disableHover bgColor="grayShades.g300">
                {currentItem.label}
                <Icon icon="INTERFACE_CHEVRON_DOWN" size={ImageSize.medium} />
              </ToggleButton>
            </StyledDropdownToggle>
            <Menu className="thematicSelectionDropdownMenu">
              {options.map(option => {
                return (
                  <Item
                    disabled={currentItem.id === option.id}
                    onClick={() => {
                      setCurrentItem(option);
                      setThematicSelection(option);
                    }}
                  >
                    <span>{option.label}</span>
                  </Item>
                );
              })}
            </Menu>
          </StyledDropdown>
        </div>
      )}
      {benchmark && (
        <>
          <Label>{t(label)}</Label>
          <StyledDropdown direction="down" isOpen={isDropdownOpen} toggle={() => openDropdown(!isDropdownOpen)}>
            <StyledDropdownToggle>
              <ToggleButton disableHover bgColor="grayShades.g300">
                {t(currentItem.label)}
                <Icon icon="INTERFACE_CHEVRON_DOWN" size={ImageSize.medium} />
              </ToggleButton>
            </StyledDropdownToggle>
            <Menu className="thematicSelectionDropdownMenu">
              {options.map(option => {
                return (
                  <Item
                    disabled={currentItem.id === option.id}
                    onClick={() => {
                      setCurrentItem(option);
                      setThematicSelection(option);
                    }}
                  >
                    <span>{t(option.label)}</span>
                  </Item>
                );
              })}
            </Menu>
          </StyledDropdown>
        </>
      )}
    </>
  );
};

export default ThematicSelectionDropdown;
